module.exports = __webpack_public_path__ + "static/media/whycss.6298277a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/whycss.png
// module id = 214
// module chunks = 0